import _defineProperty from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { OneTrustApiValidationError } from './validation';
/**
 * @example
 * ",C0001,C0002" => ["C0001", "C0002"]
 */
var normalizeActiveGroupIds = function normalizeActiveGroupIds(oneTrustActiveGroups) {
  return oneTrustActiveGroups.trim().split(',').filter(Boolean);
};
export var OtConsentModel;
(function (OtConsentModel) {
  OtConsentModel["optIn"] = "opt-in";
  OtConsentModel["optOut"] = "opt-out";
  OtConsentModel["implicit"] = "implied consent";
})(OtConsentModel || (OtConsentModel = {}));
export var getOneTrustGlobal = function getOneTrustGlobal() {
  // window.OneTrust = {...} is used for user configuration e.g. 'Consent Rate Optimization'
  // Also, if "show banner" is unchecked, window.OneTrust returns {geolocationResponse: {…}} before it actually returns the OneTrust object
  // Thus, we are doing duck typing to see when this object is 'ready'
  // function OptAnonWrapper()  is the idiomatic way to check if OneTrust is ready, but polling for this works
  var oneTrust = window.OneTrust;
  if (!oneTrust) return undefined;
  if (typeof oneTrust === 'object' && 'OnConsentChanged' in oneTrust && 'IsAlertBoxClosed' in oneTrust && 'GetDomainData' in oneTrust) {
    return oneTrust;
  }
};
export var getOneTrustActiveGroups = function getOneTrustActiveGroups() {
  var groups = window.OnetrustActiveGroups;
  if (!groups) return undefined;
  if (typeof groups !== 'string') {
    throw new OneTrustApiValidationError("window.OnetrustActiveGroups is not a string", groups);
  }
  return groups;
};
export var getNormalizedActiveGroupIds = function getNormalizedActiveGroupIds() {
  var oneTrustActiveGroups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getOneTrustActiveGroups();
  if (!oneTrustActiveGroups) {
    return [];
  }
  return normalizeActiveGroupIds(oneTrustActiveGroups || '');
};
var normalizeGroupInfo = function normalizeGroupInfo(groupInfo) {
  return {
    groupId: groupInfo.CustomGroupId.trim()
  };
};
/**
 * get *all* groups / categories, not just active ones
 */
export var getAllGroups = function getAllGroups() {
  var oneTrustGlobal = getOneTrustGlobal();
  if (!oneTrustGlobal) return [];
  return oneTrustGlobal.GetDomainData().Groups.map(normalizeGroupInfo);
};
export var getNormalizedCategories = function getNormalizedCategories() {
  var activeGroupIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getNormalizedActiveGroupIds();
  return getAllGroups().reduce(function (acc, group) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, group.groupId, activeGroupIds.includes(group.groupId)));
  }, {});
};
/**
 *  We don't support all consent models, so we need to coerce them to the ones we do support.
 */
export var coerceConsentModel = function coerceConsentModel(model) {
  switch (model) {
    case OtConsentModel.optIn:
    case OtConsentModel.implicit:
      return 'opt-in';
    case OtConsentModel.optOut:
      return 'opt-out';
    default:
      // there are some others like 'custom' / 'notice' that should be treated as 'opt-out'
      return 'opt-out';
  }
};